import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageViewOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
  currentPrompt: string
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-3">
      <GenerateImageOptionButton
        title="Close up"
        value="close up view"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('close up view')}
      />
      <GenerateImageOptionButton
        title="From above"
        value="view from above"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('view from above')}
      />
      <GenerateImageOptionButton
        title="From behind"
        value="view from behind"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('view from behind')}
      />
    </div>
  )
}

export default GenerateImageViewOptions
